export default __webpack_public_path__ + "static/media/login-segment-disabled-mail-icon.ee5ed1e2.svg";